import { FixedAssetInitialRecognitionsService } from "./../../../services/documents/FixedAssetInitialRecognitionsService";
import React from "react";
import { IAppEntity } from "../../entities";
import { DocumentService } from "../../../services/documents/DocumentService";
import { CreateFixedAssetInitialRecognitionsDto } from "../../../dtos/documents/FixedAssetInitialRecognitions/CreateFixedAssetInitialRecognitionsDto";
import { FixedAssetInitialRecognitionsDetail } from "../../../components/Pages/Documents/FixedAssetInitialRecognitions/FixedAssetInitialRecognitionsDetail";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupFixedAssetInitialRecognitions } from "../../../components/Shared/NewForms/NFLookupFixedAssetInitialRecognitions";
import FixedAssetInitialRecognitionsList from "../../../components/Pages/Documents/FixedAssetInitialRecognitions/FixedAssetInitialRecognitionsList";

export const FixedAssetInitialRecognitions: IAppEntity = {
  entityType: "document",
  title: "Fixed Asset Initial Recognitions",
  pluralTitle: "Fixed Asset Initial Recognitions",
  apiUrl: "FixedAssetInitialRecognitions",
  apiEnum: ReferenceTypes.DocumentFixedAssetInitialRecognition,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(FixedAssetInitialRecognitionsDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(FixedAssetInitialRecognitionsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupFixedAssetInitialRecognitions, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () =>
    new FixedAssetInitialRecognitionsService("FixedAssetInitialRecognitions"),
  getEmptyModel: () => {
    const model: CreateFixedAssetInitialRecognitionsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      documentDate: new Date(),
      documentNumber: "",
      status: 0,
      
      createdDate: new Date(),
      fixedAssetInitialRecognitionGoods: [],
    };
    return model;
  },
};
